// extracted by mini-css-extract-plugin
export var divider = "_qq-0";
export var systemMessage = "_qq-1";
export var systemMessageWrapper = "_qq-2";